import { Catalog } from "./Catalog.index";

export default Catalog;
